export const formatHref = (href = '') => {
    if (!href)
        return '';
    const lowerCaseHref = href.toLowerCase();
    if (lowerCaseHref.match(/(http|ftp).*/))
        return href;
    if (lowerCaseHref.includes('@'))
        return `mailto:${href}`;
    return `//${href}`;
};
//# sourceMappingURL=format-href.js.map